module.exports = __webpack_public_path__ + "img/ico_option_minus.f44cfa9f.svg";